// Shared number/date formatting helpers. Previously re-declared per page:
// fmtPct x6 (3 different signatures), fmtNumber x3 (identical), fmtDate x3
// (identical bar one dash-glyph difference). See
// Engineering Wiki/Projects/Trader/"Duplicate frontend formatting and colour
// helpers.md" for the audit. NOT consolidated here (left in place, on
// purpose): Assessment.js's fmtPct delegates to its own fmtSignedMagnitude
// (scientific/compact-suffix formatting, not a plain duplicate); Backtest.js's
// fmtMoney/fmtPnl and Allocator.js's fmtMoney are different formatters (CAD/USD
// compact-suffix P&L vs plain Intl.NumberFormat currency), not duplicates of
// each other despite the shared name.

function num(value) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return null;
  return Number(value);
}

// Superset signature (ports PortfolioProfiles.js / VersionCompare.js verbatim,
// already identical): optional sign, '-' for null/NaN.
export function fmtPct(value, digits = 1, signed = false) {
  const n = num(value);
  if (n === null) return '-';
  const sign = signed && n > 0 ? '+' : '';
  return `${sign}${n.toFixed(digits)}%`;
}

// Ports Allocator.js / PortfolioProfiles.js / VersionCompare.js verbatim
// (byte-identical).
export function fmtNumber(value, digits = 0) {
  const n = num(value);
  if (n === null) return '-';
  return n.toLocaleString(undefined, { maximumFractionDigits: digits, minimumFractionDigits: digits });
}

// Ports Allocator.js / VersionCompare.js verbatim (2 of 3 sites; Portfolio.js
// used '—' instead of '-' for the null case, standardized here).
export function fmtDate(value) {
  if (!value) return '-';
  const d = new Date(`${value}T00:00:00`);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}

// Drawdown basis label (owner ruling 2026-09-27): API payloads carry dd_basis
// 'mtm' (mark-to-market: open options at the model mark each day) or 'cost'; a
// payload without the field predates it and is cost basis.
export function ddBasisLabel(basis) {
  return basis === 'mtm' ? 'mark-to-market' : 'cost basis (legacy)';
}
